<template>
  <div>
    <!-- 企业主 -->
    <!-- :disabled="!psubmitFlag" -->
    <!-- :disabled="!dataForm.years_working" -->
    <!--  :disabled="!dataForm.profession" -->
    <!-- :disabled="!dataForm.monthly_income" -->
    <!--  :disabled="!dataForm.company_name" -->
    <!-- :disabled="!dataForm.company_phone"  -->
    <!-- :disabled="!dataForm.company_region" -->
    <!-- :disabled="!dataForm.company_address"  -->
    <!-- :disabled="!dataForm.salary_way" -->
    <popu-action-select v-model="dataForm.years_working" @click="confirmClickNum('years_working','years_working_num')" class="click-num"  :placeholder="$t('baseInfo.workOrBusinessYears')[1]" :data-list="$t('baseInfo.workOrBusinessYearsList')" :is-focus-point.sync="isFocusPoint" />
    <popu-action-select v-model="dataForm.profession" @click="confirmClickNum('profession','profession_num')" class="click-num"  name="company_industry" placeholder="baseInfo.companyIndustry" :data-list="$t('baseInfo.industryList')" :is-focus-point.sync="isFocusPoint" />
    <popu-action-select v-model="dataForm.monthly_income" @click="confirmClickNum('monthly_income','monthly_income_num')" class="click-num" placeholder="baseInfo.incomeLevel" :data-list="$t('baseInfo.incomeLevelList')" :is-focus-point.sync="isFocusPoint" />
    <van-field v-model="dataForm.company_name"  @click="confirmClickNum('company_name','company_name_num')" name="companyName" :rules="rules.CompanyName" type="text" class="form-item click-num" :placeholder="$t('baseInfo.companyname')" />
    <van-field v-model="dataForm.company_phone" @click="confirmClickNum('company_phone','company_phone_num')"  :maxlength="maxLength" :rules="rules.companyPhone" name="companyPhone" type="tel" class="form-item click-num" :placeholder="$t('baseInfo.companyTel')" />
    <popup-area v-model="dataForm.company_region" @click="confirmClickNum('company_region','company_region_num')" title="baseInfo.companyArea" placeholder="baseInfo.companyArea" :is-focus-point.sync="isFocusPoint" @onFinish="areaFinish" />
    <van-field v-model="dataForm.company_address"  @click="confirmClickNum('company_address','company_address_num')" name="companyAddress" :rules="rules.CompanyAddress" type="text" class="form-item click-num" :placeholder="$t('baseInfo.companyDetailAddres')" />
    <popu-action-select v-model="dataForm.salary_way" @click="confirmClickNum('salary_way','salary_way_num')" class="click-num" name="salary_way" placeholder="baseInfo.salaryType" :data-list="$t('baseInfo.payDayTypeList')" :is-focus-point.sync="isFocusPoint" />
    <popu-action-select v-model="dataForm.pay_day" @click="confirmClickNum('pay_day','pay_day_num')" class="click-num"  name="pay_day" placeholder="baseInfo.payDay" :data-list="paydayList" :is-focus-point.sync="isFocusPoint" />
  </div>
</template>

<script>
import perfectInformation from '../../perfectInformation'
import rules from '@/utils/rules'
import { validWhatsapp } from '@/utils/validate'

import PopupArea from '@/components/popupArea'

export default {
  name: 'BusinessOwner',
  components: { PopupArea },
  mixins: [perfectInformation],
  props: {
    psubmitFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules,
      submitFlag: false,
      paydayList: this.$t('baseInfo.weekList'),
      isGetData: false,
      dataForm: {
        years_working: '', // 经营年限
        profession: '', // 公司所属行业
        monthly_income: '', // 月收入
        company_name: '', // 公司名称
        company_phone: '', // 公司电话
        company_provinces: '', // 公司所在地区省份
        company_city: '', // 公司所在市/县
        company_county: '', // 公司所在市区
        company_address: '', // 公司详细地址
        salary_way: '', // 发薪方式
        pay_day: '', // 发薪日
        company_region: ''
      }
    }
  },
  computed: {
    maxLength() {
      return 13
      // if (this.dataForm.company_phone.indexOf('09') === 0) {
      //   return 11
      // } else if (this.dataForm.company_phone.indexOf('63') === 0) {
      //   return 12
      // } else {
      //   return 10
      // }
    }
  },
  watch: {
    'dataForm.salary_way': {
      handler(v1, v2) {
        if (v1 !== v2) this.paydayList = this.getPaydayList(v1) || this.$t('baseInfo.weekList')
      }
    }
  },

  methods: {
    getPaydayList(val) {
      if (!val) return
      let dayList = []
      if (!this.isGetData) this.dataForm.pay_day = ''
      this.isGetData = false
      const item = this.$t('baseInfo.payDayTypeList').find(item => { return item.name + '' === val + '' })
      dayList = this.$t(`baseInfo.${Number(item.val) < 3 ? 'weekList' : 'payDayList'}`)
      return dayList
    },
    validWhatsapp() {
      if (!validWhatsapp(this.dataForm.company_phone)) {
        this.dataForm.company_phone = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.is-content){
  padding-bottom: 300px;
}
</style>
